var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMk1Select(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28505 3.09598C3.19865 3.14878 3.08825 3.25918 3.03545 3.34558C2.93945 3.50398 2.93945 3.61438 2.93945 14.808C2.93945 26.0016 2.93945 26.112 3.03545 26.2704C3.27545 26.664 3.76025 26.7264 4.08185 26.4048L4.25945 26.232L4.27385 20.904L4.28345 15.576H8.05145H11.8195V17.0496C11.8195 18.4176 11.8243 18.5376 11.9155 18.72C11.9683 18.8256 12.0787 18.9552 12.1651 19.008C12.3187 19.104 12.4243 19.104 16.3075 19.104C20.2051 19.104 20.2963 19.104 20.4547 19.008C20.6755 18.8784 20.8051 18.624 20.7811 18.3984C20.7667 18.2832 20.2387 17.2656 19.3027 15.5424C18.5059 14.0688 17.8531 12.84 17.8531 12.816C17.8579 12.7872 18.5059 11.5728 19.3027 10.1088C20.1427 8.56798 20.7571 7.37758 20.7763 7.27678C20.8051 7.05598 20.6851 6.80638 20.4643 6.66238L20.3011 6.55198H16.7347H13.1683L13.1539 4.97278L13.1395 3.39358L13.0195 3.26398C12.7699 2.99038 12.9715 2.99998 8.01785 2.99998C3.53945 2.99998 3.43865 2.99998 3.28505 3.09598ZM11.8195 9.28798V14.232H8.05145H4.28345V9.28798V4.34398H8.05145H11.8195V9.28798Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk1Select);
export default __webpack_public_path__ + "static/media/mk1_select.cc46303efad098c943f064675ddffd22.svg";
export { ForwardRef as ReactComponent };